import React, { useId } from 'react';
import { PiEyedropper } from 'react-icons/pi';

type ColorEyedropperInputProps = {
  color: string;
  disabled?: boolean;
  ariaLabel: string;
  title?: string;
  onColorChange: (hex: string) => void;
  onColorBlur?: () => void;
  className?: string;
};

/**
 * Native color input triggered by an eyedropper icon (not a filled paint droplet).
 */
const ColorEyedropperInput: React.FC<ColorEyedropperInputProps> = ({
  color,
  disabled = false,
  ariaLabel,
  title,
  onColorChange,
  onColorBlur,
  className = '',
}) => {
  const inputId = useId();
  const colorInputValue =
    color && /^#[0-9A-Fa-f]{6}$/.test(color) ? color : '#ffffff';

  return (
    <label
      htmlFor={inputId}
      className={`relative inline-flex h-8 w-8 shrink-0 cursor-pointer items-center justify-center rounded-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 disabled:cursor-not-allowed disabled:opacity-50 ${className}`}
      title={title ?? ariaLabel}
    >
      <input
        id={inputId}
        type="color"
        className="absolute inset-0 h-full w-full cursor-pointer opacity-0 disabled:cursor-not-allowed"
        value={colorInputValue}
        onChange={(event) => onColorChange(event.target.value)}
        onBlur={onColorBlur}
        disabled={disabled}
        aria-label={ariaLabel}
      />
      <PiEyedropper className="h-5 w-5" aria-hidden />
    </label>
  );
};

export default ColorEyedropperInput;
